<main>
    <div class="wrapper">
      <div class="heading">
        <img class="login-user" src="../../assets/images/user-imge.png" alt="login-suer">
        <h1>Login</h1>
        <!-- <p class="account-heading">or use your account</p> -->
      </div>
      <form  class="w-100"   #login="ngForm" (ngSubmit)="(login.form.valid  && loginSubmit())">
        <div class="form-group">
          <input type="text" class="form-control" id="email" placeholder="Enter Username" name="username" [(ngModel)]="filter.username" #usrName="ngModel" required maxlength="15">
          <div *ngIf="login.submitted">
             <div *ngIf="usrName.errors?.required" class="invalid-error p-1">
               Enter Username.
             </div>
         </div>

        </div>
        <div class="form-group passwod-box ">
            <input  class="form-control" id="password" placeholder="Enter Password" name="password" [type]="hidePassword ? 'password' : 'text'" [(ngModel)]="filter.password" #usrPassword="ngModel" required maxlength="15">
            <div class="eye-menu">
             <i class="fal fa-eye"  (click)="togglePasswordVisibility()"></i>
            </div>
            <div *ngIf="login.submitted">
                <div *ngIf="usrPassword.errors?.required" class="invalid-error p-1">
                  Enter Password.
                </div>
            </div>
        </div>
        
          <!-- <div class="form-group form-check align-items-start">
            <label class="form-check-label">
              <input class="form-check-input" type="checkbox"> Remember me
            </label>
          </div> -->
   
          <div class="buttn-box-main">
            <button  type="submit" class="btn btn-primary">log in</button>
          </div>
          <div class="invalid-error invalid-errord p-1">
            {{invalidError}}
          </div>
          
      </form>
    </div>
  </main>